import React, { Component } from 'react';
import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem, InputGroup, InputGroupAddon, Col, Table, Button, Form, Input,
} from 'reactstrap';
import axios from 'axios';
import qs from 'query-string';
import FontAwesome from 'react-fontawesome';

class Header extends Component {
  state = {
    isOpen: false,
    search: qs.parse(this.props.location.search).search,
  }

  logoutUser = () => {
    // logout user and redirect to login
    axios.post('/api/logoutUser', {headers:{ Authorization: localStorage.getItem('token') } })
      .then((response) => {
        // console.log(response.data);
        if (response.data.msg) {
          localStorage.removeItem('token');
          this.props.history.push('/');
        }
      }).catch((err) => {
        // logout user and redirect to login
        console.error(err.response);
      });
  }


  render() {
    return (
      <Navbar className="mb-4" color="dark" dark expand="md">
        <NavbarBrand href="/dashboard"><img className="w-50" src="/assets/img/checkoff-credit_logo_stripped_small.png" alt="" /></NavbarBrand>
        <NavbarToggler onClick={() => { this.setState({ isOpen: !this.state.isOpen }); }} />
        <Collapse isOpen={this.state.isOpen} navbar>
          <Nav className="ml-auto" navbar>
            <NavItem>
              <Form onSubmit={(e) => {
                e.preventDefault();
                window.location.href = `/dashboard?search=${this.state.search}`;
              }}
              >
                <InputGroup>

                  <Input
                    onChange={(e) => {
                      this.setState({ search: e.target.value });
                    }}
                    value={this.state.search}
                    placeholder="Search for Client"
                  />
                  {' '}
                  <InputGroupAddon addonType="append">
                    <Button
                      type="submit"
                      size="sm"
                      color="info"
                      className="btnsecondary"
                    >
                      <FontAwesome name="search" />
                    </Button>

                  </InputGroupAddon>
                </InputGroup>
              </Form>
            </NavItem>
            <NavItem>
              <NavLink href="/dashboard">Clients</NavLink>
            </NavItem>
            {/* <NavItem>
              <NavLink href="/employer">Employers</NavLink>
            </NavItem> */}
            <NavItem>
              <NavLink href="/allloans">
                {' '}
                {this.props.user.employer == 'CHECKOFF' ? (
                  <span>
                    Loans
                    {' '}

                  </span>
                ) : null}

              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink href="/mandates">
                {' '}
                {this.props.user.employer == 'CHECKOFF' ? (
                  <span>
                    Mandates
                    {' '}

                  </span>
                ) : null}

              </NavLink>
            </NavItem>
            <UncontrolledDropdown nav inNavbar>
              <DropdownToggle nav caret>
                {this.props.user ? this.props.user.name : null}
              </DropdownToggle>
              <DropdownMenu right>
                {this.props.user.employer == 'CHECKOFF' ? (
                  <span>
                    <DropdownItem tag="a" href="/users">
                      Manage Users
                    </DropdownItem>
                    <DropdownItem divider />
                    {' '}

                  </span>
                ) : null}
                <DropdownItem tag="a" onClick={this.logoutUser}>
                  Log Out
                </DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown>
          </Nav>
        </Collapse>
      </Navbar>
    );
  }
}

export default Header;
